<template>
  <div id="container" :class="containerClass">
    <!--用於加載影片data的臨時canvas（用於後續compute）-->
    <canvas
      id="tmp_can"
      :width="VWidth"
      :height="VHeight"
      style="display: none"
    ></canvas>
    <!--用於顯示計算像素點（摳圖）後的影片canvas-->
    <!-- <div
      ref="canv_box"
      class="canv_box"
      :style="{ width: `${boxWidth * size}px`, height: `${boxWidth * (VHeight / VWidth) * size}px` }"
      v-if="showCanvas"
    > -->
    <div
      ref="canv_box"
      class="canv_box"
      :style="{ width: `${widthSize}px`, height: `${heightSize}px` }"
      v-show="showCanvas"
    >
      <canvas
        @click="pauseDigitalHuman"
        id="video_can"
        :width="VWidth"
        :height="VHeight"
      ></canvas>
      <img
        ref="pauseBtn"
        class="pauseBtn"
        @click="playDigitalHuman"
        v-show="shouldShowPauseBtn"
        src="../../static/pause.png"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    // video的完整的HTML DOM對象
    videoDom: {
      // type: HTMLVideoElement,
      default: null,
    },
    edit: {
      type: Boolean,
      default: true,
    },
    displayEdit: {
      type: Boolean,
      default: false,
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
    aiAnchorHeight: {
      type: Number,
      default: 900,
    },
  },
  data() {
    return {
      // 外框用來定位
      containerClass: "left",
      // box的寬度
      boxWidth: 200,
      // 大小
      size: "s",
      // 是否顯示canvas
      showCanvas: false,
      // 寬
      VWidth: 0,
      // 高
      VHeight: 0,
      // 顔色
      filterColor: "",
      is_auto: false,
      // 是否初始化
      is_init: true,
      setTimer: null,
      widthSize: 0,
      heightSize: 0,
      shouldShowPauseBtn: false,
    };
  },
  mounted() {
    let _this = this;
    // 移動端並且是編輯的時候，boxWidth小一些
    // if (_this.isMobile) _this.boxWidth = 100;
    // 移動端編輯，初始化後再去執行數據
    if (_this.edit && _this.is_init && _this.isMobile) _this.$emit("loaded");
    _this.is_init = false;

    //用於存儲摳圖的顏色值數組
    // let colorFilterArr = {
    //   r: [],
    //   g: [],
    //   b: []
    // };

    let processor = {
      doLoad: function () {},
      timerCallback: function () {},
      computeFrame: function () {},
    };
    this.videoDom.onloadedmetadata = () => {
      window.URL.revokeObjectURL(_this.videoDom.src);
      // console.log(
      //   `影片原始尺寸 寬：${_this.videoDom.videoWidth} 高：${_this.videoDom.videoHeight}`
      // );
      _this.VWidth = _this.videoDom.videoWidth;
      _this.VHeight = _this.videoDom.videoHeight;

      processor.width = _this.videoDom.videoWidth;
      processor.height = _this.videoDom.videoHeight;
      processor.doLoad();
    };

    processor.doLoad = function doLoad() {
      this.video = _this.videoDom;
      this.tmp_can = document.getElementById("tmp_can");
      this.ctx1 = this.tmp_can.getContext("2d");
      this.video_can = document.getElementById("video_can");
      this.ctx2 = this.video_can.getContext("2d");

      let self = this;
      this.video.addEventListener(
        "play",
        function () {
          _this.$refs.canv_box.style.display = "block";
          self.timerCallback();
        },
        false
      );
      // 前臺展示如果是初始化，走下面的initVideo
      if (!_this.edit) window.initVideo(_this.is_auto);
    };

    processor.timerCallback = function timerCallback() {
      if (this.video.paused || this.video.ended) {
        return;
      }
      this.computeFrame();
      let self = this;
      this.setTimer = setTimeout(function () {
        self.timerCallback();
      }, 0);
    };

    processor.computeFrame = function computeFrame() {
      this.ctx1.drawImage(this.video, 0, 0, this.width, this.height);
      let frame = this.ctx1.getImageData(0, 0, this.width, this.height);
      let l = frame.data.length / 4;
      for (let i = 0; i < l; i++) {
        let r = frame.data[i * 4 + 0];
        let g = frame.data[i * 4 + 1];
        let b = frame.data[i * 4 + 2];
        //if (colorFilterArr.r.includes(r) && colorFilterArr.g.includes(g) && colorFilterArr.b.includes(b)) frame.data[i * 4 + 3] = 0;
        //if (r>=0 && r<=35 && g>=100 && g<=170 && b>=20 && b<=90) frame.data[i * 4 + 3] = 0;
        //if (r>=0 && r<=36 && g>=181 && g<=251 && b>=0 && b<=36) frame.data[i * 4 + 3] = 0;
        if (g - r > 30 && g - b > 30) frame.data[i * 4 + 3] = 0;
      }
      this.ctx2.putImageData(frame, 0, 0);
      return;
    };

    if (_this.edit || _this.displayEdit) {
      // 監聽ai主播數據改變
      window.updateAiAnchor = _this.updateAiAnchorEvent;
      // 監聽組件外影片的播放暫停事件
      window.editUpdateVideoStatus = _this.videoBtnStatus;
    }

    // 監聽小影片播放事件，觸發大影片播放
    this.$root.$on("play-digital-human", () => {
      this.playDigitalHuman();
    });

    // 監聽小影片暫停事件，觸發大影片暫停
    this.$root.$on("pause-digital-human", () => {
      this.pauseDigitalHuman();
    });

    // 監聽來自第一份程式的 loopPlay 變更事件
    this.$root.$on("update-loopPlay", (newLoopPlayValue) => {
      // console.log(`接收到新的 loopPlay 值: ${newLoopPlayValue}`);
      _this.loopPlay = newLoopPlayValue;

      if (_this.loopPlay === 0) {
        // console.log("設置 loopPlay 為 0，影片將播放一次後暫停");
        _this.videoDom.loop = false;
        _this.videoDom.addEventListener("ended", _this.handleVideoEnded);
      } else {
        // console.log("設置 loopPlay 為 1，影片將循環播放");
        _this.videoDom.loop = true;
        _this.videoDom.removeEventListener("ended", _this.handleVideoEnded);
      }
    });

    this.showCanvas = true;
    this.$nextTick(() => {
      if (this.$refs.pauseBtn) {
        this.$refs.pauseBtn.style.display = "none";
      } else {
        console.warn("pauseBtn is undefined");
      }
    });
  },
  methods: {
    // ai主播改變
    updateAiAnchorEvent(data) {
      this.handleLoopPlayChange(data.value.loopPlay);
      if (
        this.$refs.canv_box &&
        (data.type == "initAuto" || data.type == "init")
      ) {
        this.$refs.canv_box.style.display = "none";
      }
      // console.log("監聽了ai主播數據的改變", data);

      // console.log("現在 loopPlay 的值", data.value.loopPlay);
      this.loopPlay = data.value.loopPlay;
      if (this.loopPlay === 0) {
        this.videoDom.loop = false;
        this.videoDom.addEventListener("ended", this.handleVideoEnded);
      } else {
        this.videoDom.loop = true;
        this.videoDom.removeEventListener("ended", this.handleVideoEnded);
      }

      this.filterColor = data.value.color;
      this.containerClass = data.value.position;
      this.getSize(data.value.size);
      // 把 data 傳來的尺寸存進 size 供 watch 中的 getSize 使用
      this.size = data.value.size;
      // if (this.displayEdit) this.containerClass = 'displayEdit'
      // 展示頁需要的自動播放init
      if (data.type == "initAuto") {
        this.showCanvas = true;
        this.is_auto = true;
      }
      // 展示頁需要的init（不自動播放）
      if (data.type == "init") {
        this.showCanvas = true;
        this.is_auto = false;
      }
      // 下面是編輯需要的===========================
      // 重置ai
      if (data.type == "reset") {
        this.showCanvas = false;
        this.filterColor = "";
        this.containerClass = "left";
        // this.size = 1
      }
      // 新增ai主播的canvas
      if (data.type == "add") {
        this.showCanvas = true;
        this.videoBtnStatus(false);
      }
      // 刪除ai主播的canvas
      if (data.type == "del") {
        this.showCanvas = false;
      }
      // 傳當前canvas的背景色
      if (data.type == "color") {
        this.filterColor = data.value.color;
      }
      // 更改當前canvas的位置
      if (data.type == "position") {
        this.containerClass = data.value.position;
      }
      // 更改當前canvas的大小
      if (data.type == "size") {
        // this.size = this.getSize(data.value.size)
        this.getSize(data.value.size);
      }
      if (this.displayEdit) {
        this.containerClass += " displayEdit";
      }
    },
    // 影片播放還是暫停是否顯示按鈕
    videoBtnStatus(type) {
      if (!this.$refs.pauseBtn) return;
      if (type) {
        this.$refs.pauseBtn.style.display = "block";
      } else {
        this.$refs.pauseBtn.style.display = "none";
      }
    },
    // ai主播點擊播放
    playDigitalHuman() {
      if (this.videoDom && this.videoDom.paused) {
        this.videoDom.currentTime = 0; // 確保從頭播放
        this.videoDom
          .play()
          .then(() => {
            this.showCanvas = true; // 顯示大影片
            this.$nextTick(() => {
              // 確保 pauseBtn 存在後再操作
              if (this.$refs.pauseBtn) {
                this.$refs.pauseBtn.style.display = "none"; // 隱藏暫停按鈕
              } else {
                console.warn("pauseBtn 未找到");
              }
            });
          })
          .catch((error) => {
            console.warn("播放大影片時遇到錯誤：", error);
          });
      }
    },

    // ai主播點擊暫停
    pauseDigitalHuman() {
      if (this.videoDom && !this.videoDom.paused) {
        this.videoDom.pause();
        this.$nextTick(() => {
          // 確保 pauseBtn 存在後再操作
          if (this.$refs.pauseBtn) {
            this.$refs.pauseBtn.style.display = "block"; // 顯示暫停按鈕
          } else {
            console.warn("pauseBtn 未找到");
          }
        });
      }
    },

    handleVideoEnded() {
      this.videoDom.pause();
      this.videoDom.currentTime = 0; // 重置播放時間
      this.$nextTick(() => {
        // 確保 pauseBtn 存在後再操作
        if (this.$refs.pauseBtn) {
          this.$refs.pauseBtn.style.display = "block"; // 顯示暫停按鈕
        } else {
          console.warn("pauseBtn 未找到");
        }
      });

      // 隱藏大影片
      this.showCanvas = false;
      if (this.videoDom) {
        this.videoDom.style.display = "none";
      }
    },
    handleLoopPlayChange(newLoopPlayValue) {
      this.loopPlay = newLoopPlayValue;

      this.$emit("update-loopPlay", newLoopPlayValue);
    },
    // 計算尺寸
    getSize(value) {
      const mobileSizes = {
        s: { width: 110, height: 200 },
        m: { width: 130, height: 235 },
        l: { width: 185, height: 325 },
      };
      const desktopSizes = {
        s: {
          width: this.aiAnchorHeight * 0.57 * 0.3,
          height: this.aiAnchorHeight * 0.3,
        },
        m: {
          width: this.aiAnchorHeight * 0.57 * 0.5,
          height: this.aiAnchorHeight * 0.5,
        },
        l: {
          width: this.aiAnchorHeight * 0.57 * 0.7,
          height: this.aiAnchorHeight * 0.7,
        },
      };
      const sizes = this.$isMobile() ? mobileSizes : desktopSizes;
      if (sizes[value]) {
        this.widthSize = sizes[value].width;
        this.heightSize = sizes[value].height;
      }
      return;
    },
  },
  watch: {
    aiAnchorHeight() {
      this.getSize(this.size);
    },
  },
  // 銷毀前清除
  beforeDestroy() {
    clearTimeout(this.setTimer);
  },
};
</script>
<style lang="less" scoped>
#container {
  position: absolute;
  bottom: 0;
  z-index: 998;

  //ai左邊
  &.left {
    left: 0;
  }

  //ai居中
  &.center {
    left: 50%;
    transform: translateX(-50%);
  }

  //ai右邊
  &.right {
    right: 0;
  }

  &.displayEdit {
    pointer-events: none;
  }

  .canv_box {
    position: relative;
    display: none;
  }

  .pauseBtn {
    display: none;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 10;
    width: 50px;
    height: 50px;
    cursor: pointer;
  }

  #video_can {
    width: 100%;
    max-height: 100%;
    position: absolute;
    bottom: 0;
    /* 給扣出來的視頻加背景圖 */
    /* background-image: url(reward.jpg);
        background-repeat: no-repeat;
        background-size: 100%;
        background-position: 0 0; */
  }
}
</style>
